<template>
  <div class="permission-group">
    <el-container class="permission-group-panel"
                  :style="{ height: height + 'px' }">

      <div class="permission-group-left">
        <div class="permission-group-header">
          <b>权限组</b>
        </div>
        <el-scrollbar
          wrap-style="overflow-x: hidden;"
          :style="{ height: height - 48 + 'px' }">
          <ul class="permission-group-list">
            <li v-for="(permissionGroup, index) in permissionGroupList"
                :key="index"
                :class="[activePermissionGroup===permissionGroup?'active':'']"
                @click="onActivePermissionGroup(permissionGroup)">
              <el-badge :value="getSelected(permissionGroup).length + '/' + permissionGroup.permission_ids.length">
                {{permissionGroup.name}}
              </el-badge>
            </li>
          </ul>
        </el-scrollbar>
      </div>

      <div class="permission-group-right">
        <div class="permission-group-header">
          <b>权限分配</b>
        </div>
        <el-scrollbar
          wrap-style="overflow-x: hidden;"
          :style="{ height: height - 48 + 'px' }">
          <div class="permission-list">
            <!-- 全选按钮 -->
            <el-checkbox
              v-if="activePermissionGroup"
              v-show="activePermissionGroup.permissions.length > 1"
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              border
              size="medium">全选
            </el-checkbox>
            <!-- 已选择权限组的权限列表 -->
            <el-checkbox-group
              v-if="activePermissionGroup"
              @change="handleCheckedChange"
              v-model="currentValue">
              <el-checkbox
                v-for="{id} in activePermissionGroup.permissions"
                :key="permissionListMap[id].id"
                :label="permissionListMap[id].id"
                :disabled="permissionListMap[id].disabled"
                @change="(event) => onChange(event, id)"
                border
                size="medium">{{permissionListMap[id].name}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-scrollbar>
      </div>

    </el-container>
  </div>
</template>

<script>

// let currentDisabled = []
export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: [],
    },
    disabled: {
      type: Array,
      default: () => [],
    },
    host: {
      type: String
    }
  },
  data () {
    return {
      activePermissionGroup: null,
      permissionGroupList: [],
      permissionList: [],
      permissionListMap: {},
      checkAll: false,
      isIndeterminate: false,
      currentDisabled: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
    }),
    height () {
      let height = this.clientHeight - 250
      if (height < 300) {
        height = 300
      }
      return height
    },
    currentValue () {
      return this.value
    },
  },
  watch: {
    disabled (disabled) {
      let unselectedPermissions = _.difference(this.currentDisabled, disabled)
      let selectedPermissions = _.difference(disabled, this.currentDisabled)
      this.permissionGroupList.forEach((group) => {
        group.permission_ids.forEach((id) => {
          if (unselectedPermissions.includes(id)) {
            this.permissionListMap[id].disabled = false
          } else if (selectedPermissions.includes(id)) {
            this.permissionListMap[id].disabled = true
          }
        })
      })
      this.currentDisabled = filter.copyJson(disabled)
      this.handleCheckedChange()
    },
    activePermissionGroup () {
      this.handleCheckedChange()
    },
  },
  created () {
    this.currentDisabled = filter.copyJson(this.disabled)
    request.all.common([
      request('getPermissionTable', {host: this.host, per_page: 666}),
      request('getPermissionGroupTable', {host: this.host}),
    ]).then(res => {
      // 权限列表
      this.permissionList = res[0].data.data
      this.permissionListMap = {}
      this.permissionList.forEach((permission) => {
        permission.disabled = false
        this.permissionListMap[permission.id] = permission
      })
      // 权限组列表
      let permissionGroupList = res[1].data.data
      // 处理权限组列表
      permissionGroupList.forEach((group) => {
        group.permission_ids = []
        group.permissions.forEach(({id}) => {
          group.permission_ids.push(id)
          // 锁定的权限
          if (this.currentDisabled.includes(id)) {
            this.permissionListMap[id].disabled = true
          }
        })
      })
      this.permissionGroupList = permissionGroupList
      // 默认活跃权限组
      this.activePermissionGroup = permissionGroupList[0]
    })
  },
  mounted () {},
  methods: {
    getSelected (group) {
      let unSelected = _.difference(group.permission_ids, this.currentValue)
      return _.difference(group.permission_ids, unSelected)
    },
    onActivePermissionGroup (group) {
      this.activePermissionGroup = group
    },
    onChange (val, id) {
      if (val) {
        this.currentValue.push(id)
      } else {
        this.currentValue.splice(this.currentValue.indexOf(id), 1)
      }
      this.$emit('change', this.currentValue)
    },
    handleCheckAllChange (val) {
      let isChange = false
      this.activePermissionGroup.permission_ids.forEach((id) => {
        // 不能是禁止操作的对象
        if (!this.permissionListMap[id].disabled) {
          if (val) {
            // 添加选择的权限
            if (!this.currentValue.includes(id)) {
              this.currentValue.push(id)
              isChange = true
            }
          } else {
            // 移除选择的权限
            let index = this.currentValue.indexOf(id)
            if (index !== -1) {
              this.currentValue.splice(index, 1)
              isChange = true
            }
          }
        }
      })
      if (isChange) {
        this.$emit('change', this.currentValue)
      }
      this.isIndeterminate = false
    },
    handleCheckedChange () {
      let unSelected = _.difference(this.activePermissionGroup.permission_ids, this.currentValue)
      let checkedCount = this.activePermissionGroup.permission_ids.length - unSelected.length
      this.checkAll = checkedCount === this.activePermissionGroup.permission_ids.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.activePermissionGroup.permission_ids.length
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
@import "~@views/permission-group/permission-group.scss";
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-group/components/PermissionGroupSelect.vue